import { mapGetters } from 'vuex';

export default {
    name: 'mvtToastLinked',
    inject: ['$eventBus'],
    components: {
    },
    data: function () {
        return {
            message: '',
            iconClass: '',
            visible: false,
            title: '',
            loc: ''
        };
    },
    computed: {
        ...mapGetters('glb', ['glb'])
    },
    methods: {
        show: function (message, iconClass, title, loc) {
            this.message = message;
            this.iconClass = iconClass;
            this.title = title;
            this.visible = true;
            this.loc = loc;
        },
        hide: function () {
            this.visible = false;
            setTimeout(() => {
                this.message = '';
                this.iconClass = '';
                this.title = '';
                this.loc = '';
            }, 2000);
        }
    },
    beforeUnmount() {
        this.$eventBus.$off('toast-linked');
    },
    beforeMount() {
        !this.glb.isSSR &&
            this.$eventBus.$on('toast-linked', (data) => {
                const loc = data.loc ? data.loc : '';
                this.show(data.message, data.iconClass, data.title, loc);
                let that = this
                data.autoclose && setTimeout(() => {
                    that.hide()
                }, 30000);
                if (data.scrollClose) {
                    $(document).one('dom.scroll', function () {
                        that.hide();
                    });
                }
            });
    },
};
